import '@/bootstrap';
import store from '@/store';
import config from '@/config';

// Create axios instance
const service = window.axios.create({
  baseURL: config.apiBaseUrl,
  timeout: 60000, // Request timeout
  withCredentials: true,
});

// Request intercepter
service.interceptors.request.use(
  reqConfig => {
    /* API key (app key for this app frontend) – required when backend enforces API keys */
    const apiKey = config.apiKey;
    if (apiKey) {
      reqConfig.headers['X-Api-Key'] = apiKey;
    }
    /*set the token for the auth-headers*/
    const token = store.getters['getToken'];
    if (token) {
      reqConfig.headers['Authorization'] = 'Bearer ' + token;
      reqConfig.headers['X-Authorization'] = 'Bearer ' + token;
    }
    return reqConfig;
  },
  error => {
    // Do something with request error
    console.log(error); // for debug
    Promise.reject(error);
  }
);

// response pre-processing
service.interceptors.response.use(
  response => {
    // if (response.headers.authorization) {
    //   setLogged(response.headers.authorization);
    //   response.data.token = response.headers.authorization;
    //   response.data.token = response.headers.authorization;
    // }

    return response.data;
  },
  error => {
    console.log(error);

    // Network / CORS errors: no response object at all
    if (!error.response) {
      // Keep this generic – details will be in the browser console
      return Promise.reject(error);
    }

    const { response } = error;
    let message = error.message;
    if (response.data && response.data.errors) {
      message = response.data.errors;
    } else if (response.data && response.data.error) {
      message = response.data.error;
    }
    //console.log(message);

    const errortype = response.status;
    const theUser = store.state.user;
    /* 401: do not logout when the failure is invalid/missing API key (no user session involved) */
    if (errortype === 401) {
      const data = response.data;
      const isApiKeyError = (data && (data.error === 'Invalid or missing API key.' || data.message === 'Invalid or missing API key.'));
      if (isApiKeyError) {
        if (typeof window !== 'undefined' && window.alert) {
          window.alert('API-Schlüssel fehlt oder ist ungültig. Bitte Konfiguration prüfen.');
        }
      } else if (theUser != null) {
        store.dispatch('logout');
        window.location.href = '/';
      }
    }

    return Promise.reject(error);
  }
);

export default service;
